import { sha256 } from 'js-sha256';
/**
 * @class
 * @description This static class provides utility methods.
 * @static
 * @exports Util
 */
export default class Util {
    /**
     * Generates a hash of a random value to be used as a peer ID
     * @returns {string} Random 32 bytes hash
     * @public
     * @static
     */
    static generateRandomPeerId() {
        return Util.hash((Date.now() * Math.random()).toString());
    }
    /**
     * Gets a string and returns a hash of it. It uses the first 32 bytes of its sha256
     * @param {string} inputString value to be hashed
     * @returns {string} hashed value of the input string
     * @public
     * @static
     */
    static hash(inputString) {
        return Buffer.from(sha256(inputString)).slice(0, 32).toString();
    }
}
